import React from 'react';
import PropTypes from 'prop-types';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';

// Components
import Markdown from '@client/components/markdown/Markdown';

// Constants
import { SWISH_ID_TAG } from '@client/definitions/constants';

// Styles
import styles from './swishCard.scss';

export const SwishCard = ({ title, text, swishId }) => {
  const hasSwishIdTag = valueOrEmptyStr(text).includes(SWISH_ID_TAG);
  const markdownWithId = valueOrEmptyStr(text).replace(SWISH_ID_TAG, swishId);

  return (
    <div className={styles.swishCard}>
      <h3 className={styles.swishCardTitle}>{title}</h3>
      {hasSwishIdTag && swishId && (
        <Markdown className={styles.markdown} value={markdownWithId} />
      )}
    </div>
  );
};

SwishCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  swishId: PropTypes.string,
};
